import { CASDispositionTypes } from '../../../cimsPage/instances/cas'
import { DispositionTypes } from '../../common'

const { Create, Edit, RemoveRestore, View } = DispositionTypes({
  create: '74ffb49e-f68b-4bd7-98cb-6c5bfbcefc41',
  edit: '98d64998-a629-4512-86ab-e9cd21397f75',
  view: 'e9afa11e-abcc-4d37-8700-a84490b86996',
  removeRestore: '6a8f2ca1-6903-4461-b27e-cbcb761e060b',
  page: CASDispositionTypes,
})

export const CreateCASDispositionType = Create
export const EditCASDispositionType = Edit
export const RemoveRestoreCASDispositionType = RemoveRestore
export const ViewCASDispositionType = View

export type CASDispositionTypePermission =
  | typeof CreateCASDispositionType
  | typeof EditCASDispositionType
  | typeof RemoveRestoreCASDispositionType
  | typeof ViewCASDispositionType
